import Vue from "vue";
import configurationHandler from "@services/helpers/configurationHandler";

// local state
const getDefaultState = () => {
  return {
    value: {
      updated: false,
      index: 0,
      sides: {
        Building: {
          show: true,
          classes: [],
          iconClasses: ["bg-white", "text-primary"],
        },
        Rooms: { show: false, classes: ["disabled"], iconClasses: ["border"] },
        AirVolumes: {
          show: false,
          classes: ["disabled"],
          iconClasses: ["border"],
        },
        Devices: {
          show: false,
          classes: ["disabled"],
          iconClasses: ["border"],
        },
        Equipments: {
          show: false,
          classes: ["disabled"],
          iconClasses: ["border"],
        },
        Overview: {
          show: false,
          classes: ["disabled"],
          iconClasses: ["border"],
          skipped: false
        },
      },
      nextClasses: ["disabled"],
      previousClasses: ["disabled"],
    },
  };
};

const state = getDefaultState();

const getters = {};

const mutations = {
  updateNavigation(state, value) {
    state.value = value;
  },
  nextSide(state) {
    var skipEquipment = false;
    const keys = Object.keys(state.value.sides);
    if (state.value.index >= keys.length) return;

    if (
      state.value.index == 3 &&
      state.value.sides[keys[state.value.index + 2]].classes.includes(
        "disabled"
      ) == false
    ) {
      skipEquipment = true;
    } else if (
      state.value.sides[keys[state.value.index + 1]].classes.includes(
        "disabled"
      ) == true
    ) {
      return;
    }

    state.value.sides[keys[state.value.index]].classes.push("visited");

    state.value.sides[keys[state.value.index]].iconClasses = ["border"];
    state.value.sides[keys[state.value.index]].show = false;

    if (skipEquipment) state.value.index++;
    state.value.index++;
    state.value.sides[keys[state.value.index]].show = true;
    state.value.sides[keys[state.value.index]].iconClasses = [
      "bg-white",
      "text-primary",
    ];
    state.value.updated = true;
    configurationHandler.pageChangeStore();
  },
  previousSide(state) {
    if (state.value.index <= 0) return;

    const keys = Object.keys(state.value.sides);

    var index =
      state.value.sides[keys[state.value.index]].classes.indexOf("visited");
    if (index > -1)
      state.value.sides[keys[state.value.index]].classes.splice(index, 1);

    state.value.sides[keys[state.value.index]].show = false;
    state.value.sides[keys[state.value.index]].iconClasses = ["border"];

    if(state.value.index == 5 && state.value.sides['Overview'].skipped == true) {
      state.value.index -= 2;
    } else if (
      state.value.index == 5 &&
      state.value.sides["Equipments"].classes.includes("disabled") == true
    ) {
      state.value.sides["Equipments"].classes = ["disabled"];
      state.value.sides["Equipments"].iconClasses = ["border"];
      state.value.index--;
    }
    state.value.index--;
    state.value.sides[keys[state.value.index]].show = true;
    state.value.sides[keys[state.value.index]].iconClasses = [
      "bg-white",
      "text-primary",
    ];
    state.value.updated = true;
  },
  setSide(state, key) {
    if(state.value.sides['AirVolumes'].show == true && key == 'Overview') {
      state.value.sides['Overview'].skipped = true;
    } else if (state.value.sides[key].classes.includes("disabled") == true) {
      return;
    } else {
      state.value.sides['Overview'].skipped = false;
    }
    const keys = Object.keys(state.value.sides);
    const newIndex = keys.indexOf(key);

    if (newIndex == state.value.index) return;
    state.value.index = keys.indexOf(key);

    for (let i = keys.length - 1; i >= 0; i--) {
      if(state.value.sides['Overview'].skipped == true && (keys[i] == 'Devices' || keys[i] == 'Equipments')) {
          state.value.sides["Devices"].classes = ["disabled"];
          state.value.sides["Equipments"].classes = ["disabled"];
          continue;
      }
      state.value.sides[keys[i]].iconClasses = ["border"];
      if (i < newIndex) {
        state.value.sides[keys[i]].show = false;
        state.value.sides[keys[i]].iconClasses = ["border"];

        if (state.value.sides[keys[i]].classes.includes("visited") == false){
          state.value.sides[keys[i]].classes.push("visited");
      }
      }
      if (i > newIndex) {
        var index = state.value.sides[keys[i]].classes.indexOf("visited");
        if (index > -1) state.value.sides[keys[i]].classes.splice(index, 1);
        state.value.sides[keys[i]].show = false;
        state.value.sides[keys[i]].iconClasses = ["border"];
      }
      if (i == newIndex) {
        var index = state.value.sides[keys[i]].classes.indexOf("visited");
        if (index > -1) state.value.sides[keys[i]].classes.splice(index, 1);
        state.value.sides[keys[i]].show = true;
        state.value.sides[keys[i]].iconClasses = ["bg-white", "text-primary"];
      }
    }
    state.value.index = newIndex;
    state.value.updated = true;
    configurationHandler.pageChangeStore();
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  next({ commit }) {
    window.enableLoadingAnimation();
    setTimeout(async () => {
      commit("nextSide");
      //window.disableLoadingAnimation();
    }, 500);
  },
  previous({ commit }) {
    window.enableLoadingAnimation();
    setTimeout(async () => {
      commit("previousSide");
      //window.disableLoadingAnimation();
    }, 500);
  },
  setSide({ commit }, key) {
    window.enableLoadingAnimation();
    setTimeout(async () => {
      commit("setSide", key);
      //window.disableLoadingAnimation();
    }, 500);
  },
  resetState({ commit }) {
    window.enableLoadingAnimation();
    setTimeout(async () => {
      commit("resetState");
      window.disableLoadingAnimation();
    }, 500);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
